import React, { FormEvent, useState } from "react";
import Help, { ARTICLES } from "../../../../components/help/Help";
import {
    ActionDeflection, ActionFeedback, ActionInputFeedback, FeedbackType,
} from "../../../../__generated__/api";

interface Props {
    action: ActionFeedback;
    onChange: (feedback: ActionInputFeedback) => void;
}

const CES_VALUES = new Array(7).fill(0).map((__, i) => ({
    index: i,
    value: i + 1,
    size: "fs-4 w-100",
    color: i < 3 ? "danger" : "success",
}));
CES_VALUES[3].color = "info";
const NPS_VALUES = new Array(11).fill(0).map((__, i) => ({
    index: i,
    value: i,
    size: "fs-5 w-100",
    color: i < 5 ? "danger" : "success",
}));
NPS_VALUES[4].color = "info";
NPS_VALUES[5].color = "info";
NPS_VALUES[6].color = "info";

const FACES_VALUES = [
    {
        index: 0,
        value: "😠",
        size: "fs-4 w-100",
        color: "danger",
    },
    {
        index: 1,
        value: "🙁",
        size: "fs-4 w-100",
        color: "danger",
    },
    {
        index: 2,
        value: "😐",
        size: "fs-4 w-100",
        color: "info",
    },
    {
        index: 3,
        value: "🙂",
        size: "fs-4 w-100",
        color: "success",
    },
    {
        index: 4,
        value: "🤩",
        size: "fs-4 w-100",
        color: "success",
    },
];

const THUMBS_VALUES = [
    {
        index: 0,
        value: "👎",
        size: "fs-3 px-4 py-3",
        color: "danger",
    },
    {
        index: 1,
        value: "👍",
        size: "fs-3 px-4 py-3",
        color: "success",
    },
];

export default function Deflection(props: Props) {
    const [comment, setComment] = useState<string>();
    const [selectedValue, setSelectedValue] = useState<number>();

    const [isSubmittedComment, setSubmittedComment] = useState<boolean>();
    let values;
    if (props.action.type === FeedbackType.Ces) {
        values = CES_VALUES;
    } else if (props.action.type === FeedbackType.Nps) {
        values = NPS_VALUES;
    } else if (props.action.type === FeedbackType.Faces) {
        values = FACES_VALUES;
    } else if (props.action.type === FeedbackType.Thumbs) {
        values = THUMBS_VALUES;
    }

    const submitFeedback = (evt: FormEvent) => {
        evt.preventDefault();
        props.onChange({
            comment,
            value: selectedValue,
        });
        setSubmittedComment(true);
    };
    const changeValue = (value: number) => {
        props.onChange({
            value,
            comment,
        });
        setSelectedValue(value);
    };

    const selectedItem = (values ?? [])[props.action.selectedIndex];

    let feedbackMessage = "😞 We are sorry to hear that.";
    if (selectedItem.color === "info") {
        feedbackMessage = "😐 Thank you for your feedback.";
    } else if (selectedItem.color === "success") {
        feedbackMessage = "🎉 Thank you for the feedback!";
    }

    return (
        <div className="w-75 mx-auto">

            <h4 className="text-center w-100 mb-4">
                {feedbackMessage}
            </h4>

            {(props.action.responseMessage || isSubmittedComment) ? (
                <div className="w-100 text-center mb-3">
                    {props.action.responseMessage ?? "Thank you for your feedback. Your feedback is crucial to us."}
                </div>
            ) : (
                <div>
                    <div className="w-100 text-center mb-3">
                        Thank you for submitting this feedback, it has been recorded.
                        You can change your selected answer below.
                    </div>

                    {values && (
                        <div className="w-100 d-flex justify-content-around">
                            {values.map(value => (
                                <button
                                    key={value.index}
                                    type="button"
                                    className={`btn border ${value.size} mx-2 ${
                                        props.action.selectedIndex === value.index ? "border-3" : ""
                                    } border-${value.color}`}
                                    onClick={() => changeValue(value.index)}
                                >
                                    {value.value}
                                </button>
                            ))}

                        </div>
                    )}

                </div>
            )}

            {!isSubmittedComment && props.action.isCommentAllowed && (
                <form className="text-center mt-4 mb-3" onSubmit={submitFeedback}>

                    <div>
                        Anything else you would like to tell us about this experience?
                    </div>
                    <textarea
                        className="form-control border border-gray-500 my-2 rounded"
                        onChange={event => setComment(event.target.value)}
                        value={comment}
                    />
                    <div className="justify-content-end d-flex w-100">
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>

                </form>
            )}

            <div className="text-end w-100">
                <Help
                    articleId={ARTICLES.ACTIONS_FEEDBACK}
                    buttonClassName="btn btn-none text-light mx-auto"
                    buttonType="help"
                />
            </div>

        </div>
    );
}
